import React from 'react';
import { motion } from 'framer-motion';
import aboutBg from '../images/about-bg.jpg';

const About = () => {
  return (
    <section className="about" id="about" style={{ backgroundImage: `url(${aboutBg})` }}>
      <div className="container">
        <motion.h2 
          className="about-title"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          Serving the Pacific Northwest
        </motion.h2>
        <div className="about-grid">
          <motion.div
            className="about-card"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            whileHover={{ 
              scale: 1.03,
              boxShadow: "0 10px 20px rgba(0,0,0,0.1)"
            }}
          >
            <h3>Service Areas</h3>
            <p>We serve all 39 counties across Washington State, providing comprehensive coverage from the Pacific Coast to the eastern border, from the Canadian border to the Columbia River.</p>
          </motion.div>

          <motion.div
            className="about-card"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
            whileHover={{ 
              scale: 1.03,
              boxShadow: "0 10px 20px rgba(0,0,0,0.1)"
            }}
          >
            <h3>Western Washington</h3>
            <p>We serve all cities and communities throughout Western Washington, including Aberdeen, Hoquiam, Olympia, Tacoma, Seattle, Bellingham, Bremerton, and all surrounding areas.</p>
          </motion.div>

          <motion.div
            className="about-card"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            viewport={{ once: true }}
            whileHover={{ 
              scale: 1.03,
              boxShadow: "0 10px 20px rgba(0,0,0,0.2)"
            }}
          >
            <h3>Eastern Washington</h3>
            <p>
              We serve all cities and communities throughout Eastern Washington, including Spokane, Yakima, Wenatchee, Tri-Cities, Walla Walla, Pullman, and all surrounding areas.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About; 